Vendd.Scripts.load(function () {
    var $wrapper = $('.x-control.x-pager[data-control="pager"]');

    if ($wrapper.length < 1) return;

    var wrapper = $wrapper.get(0),
        model = null;

    var scrolled = $wrapper.data('scrolled') === true;

    wrapper.bind = function () {
        if (!isTouch()) updatePagerLinks();

        initPageSize();
        initComboPages();
    };

    wrapper.update = function () {
        var html;
        if (scrolled) {
           html = Vendd.Handlebars.parse("plPager_B", model);
        } else {
           html = Vendd.Handlebars.parse("plPager_A", model);
        }
        
        $wrapper.html(html);
        wrapper.bind();
    };

	function updatePagerLinks() {
		$('.pager').each(function (index, wrapper) {
			var $wrapper = $(wrapper); 
			//check if main product list product folder
			if ($wrapper.data('id') !== 'products') return;
			var pageSizes = $('[data-format-url="pagesize"]', $wrapper);
			var pageJumps = $('[data-format-url="page"]', $wrapper);
			var prev = $('[data-format-url="prevpage"]', $wrapper);
			var next = $('[data-format-url="nextpage"]', $wrapper);

			var url = window.location.href,
				parts = url.split('?'),
				newUrl, newParts;

			parts[0] = parts[0].replace(/\/P\d+\//i, '');

			//prev link
			newUrl = prev.attr('href');
			if (newUrl) {
				newParts = newUrl.split('?');
				newParts[0] = newParts[0].replace(/\/P\d+\//i, '');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0];
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt(prev.attr('data-page') || 0) > 1)
						newParts[0] = newParts[0] + 'p' + prev.attr('data-page') + '/';
					
					prev.attr('href', newParts[0] + '?' + newParts[1]);
				}
			}

			//next link
			newUrl = next.attr('href');
			if (newUrl) {
				newParts = newUrl.split('?');
				newParts[0] = newParts[0].replace(/\/P\d+\//i, '');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0];
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt(next.attr('data-page') || 0) > 1)
						newParts[0] = newParts[0] + 'p' + next.attr('data-page') + '/';
					next.attr('href', newParts[0] + '?' + newParts[1]);
				}
			}


			//page sizes
			pageSizes.closest('.x-pager-pagesizes').hide();
			//pageSizes.each(function (index, pageSize) {
			//	var $elem = $(pageSize);
			//	newUrl = $elem.attr('data-url');
			//	newParts = newUrl.split('?');
			//	if (newParts[0] !== parts[0]) {
			//		newParts[0] = parts[0].replace(/\/P\d+\//i, '');
			//		$elem.attr('data-url', newParts[0] + '?' + newParts[1]);
			//	}
			//});

			//pages
			pageJumps.each(function (index, pageJump) {
				var $elem = $(pageJump);
				newUrl = $elem.attr('data-url');
				newParts = newUrl.split('?');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0].replace(/\/P\d+\//i, '');
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt($elem.val() || 0) > 1)
						newParts[0] += 'p' + $elem.val() + '/';
					$elem.attr('data-url', newParts[0] + '?' + newParts[1]);
				}
			});
		});
    }

    function initPageSize() {
        var $control = $('.x-control[data-control="pager"][data-type="pageSize"]');

        if ($control.length < 1) return;

        $control.each(function (i, item) {
            if (!isTouch()) $('select', item).sSelect({ ddMaxHeight: '200px' });

            $('select', item).change(function (e) {
                document.location = $(this).find(":selected").data('url');
            });
        });
    }

    function initComboPages() {
        var $control = $('.x-control[data-control="pager"][data-type="combopages"]');

        if ($control.length < 1) return;

        $control.each(function (i, item) {
            if (!isTouch()) $('select', item).sSelect({ ddMaxHeight: '200px' });

            $('select', item).change(function (e) {
                if ($(this).hasClass('disabled')) return;

                var element = $('.x-product-list li[data-page="' + $(this).find(":selected").val() + '"]');
                if (element.length > 0) {
                    $('html,body').animate({ scrollTop: element.eq(0).offset().top - 100 }, 600);
                    return;
                }
                document.location = $(this).find(":selected").data('url');
            });
        });
    }

    wrapper.bind();

    Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModelSuccess, $wrapper, function (envelope) {
        if (envelope.message.data.data.Products.Items.length < 1)
            return;

        model = envelope.message.data.data.Pager;        
        wrapper.update();
    });
});

